export default class Responses {
  static from (responses) {
    try {
      return new User(responses);
    } catch (_) {
      return null;
    }
  }

  constructor ({ responses }) {
    this.responses = responses;
  }
};



// WEBPACK FOOTER //
// ./src/models/Responses.js